import commons from 'frontend/commons/commons';
import React from 'react';
import styles from './mainCarousel.module.css';
import { targetFromUrl } from '../../utils/url';

export default function MainCarouselSlide({ banner }) {
  const imgSplit = commons.imgUrlSliderValidator(banner.imageUrl);
  const url = commons.addBasePath(process.env.RAZZLE_PACKAGES_BASE_PATH, banner.url);
  return (
    <a
      style={{
        height: 'auto',
      }}
      href={url}
      className="block"
      target={targetFromUrl(url)}
      rel="noreferrer"
    >
      <img
        className={styles.carouselImgItem}
        src={imgSplit}
        alt={banner.title}
        onError={(e) => {
          e.target.style = 'background: #eaeaea; text-indent: 16px';
        }}
      />
    </a>
  );
}
